<template>
  <div class='indexbox'>
    <div class="searchbox">
      <p></p>
      <el-button v-hasPermi="['bind_shop', 'shop_auth']" type="primary" @click="show = true">{{ $t('lg.新增店铺')
      }}</el-button>
      <el-button v-hasPermi="['shop_delete']" type="primary" :loading='btn_alldel' @click="deleteShop">{{ $t('lg.删除店铺')
      }}</el-button>
      <el-button v-hasPermi="['shop_unbind']" type="primary" :loading='btn_allunbind' @click="allunbind">{{
        $t('lg.店铺解绑') }}</el-button>
    </div>
    <div class="tablebox">
      <div class="draggable" v-loading='loading'>
        <el-table :data="tableData" stripe @selection-change="SelectionChange" border>
          <el-table-column type="selection" fixed align='center' />
          <el-table-column :label="$t('lg.邮箱')" prop='email' align='left' fixed show-overflow-tooltip />
          <el-table-column :label="$t('lg.店铺名称')" prop='shop_name' align='left' min-width='80' show-overflow-tooltip />
          <el-table-column :label="$t('lg.创建时间')" sortable prop='create_time' align='left' min-width='80'
            show-overflow-tooltip />
          <el-table-column :label="$t('lg.平台类型')" prop='type_name' align='left' min-width='80' show-overflow-tooltip />
          <el-table-column sortable prop='end_time' align='left' min-width='80' show-overflow-tooltip>
            <template slot="header">
              {{ $t('lg.店铺授权到期日') }}
              <el-tooltip :content="$t('lg.店铺授权tip')" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lg.状态')" prop='status' align='left' fixed='right' min-width='80'
            show-overflow-tooltip>
            <template scope="scope">
              <el-button type="text" size="small" @click="lookdata(scope.row)" v-if="scope.row.status == 0">{{
                $t('lg.未授权') }}</el-button>
              <el-button type="text" size="small" @click="lookdata(scope.row)" v-if="scope.row.status == 1">{{
                $t('lg.已授权') }}</el-button>
              <el-button type="text" size="small" @click="lookdata(scope.row)" v-if="scope.row.status == 2">{{
                $t('lg.已解绑') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 店铺授权tip -->
      </div>
      <el-pagination @current-change='pagechage' background layout="total,prev, pager, next" v-show="total > 0"
        :current-page.sync="page" :page-size="10" :total="total" />
    </div>

    <el-dialog title="新增店铺" :visible.sync="show" width="50%">
      <el-form ref="form" :model="form" :rules="rules" class="formbox">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item prop="type_id">
              <span class="form_tit">{{ $t('lg.平台类型') }}*</span>
              <div class="imgbox">
                <div v-for="val in typeList" :key="val.id" @click="form.type_id = val.id">
                  <img :src="httpPath + val.type_image" alt="" :class="form.type_id == val.id ? 'actiive' : ''">
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="shop_name">
              <span class="form_tit">{{ $t('lg.店铺名称') }}*</span>
              <el-input v-model="form.shop_name" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="btnbox" v-hasPermi="['shop_auth']">
              <el-button type="primary" @click.native.prevent="onSubmit" :loading='btn_loading'>{{ $t('lg.保存')
              }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :title="$t('lg.详情')" :visible.sync="info_show" width="60%">
      <el-form ref="form" :model="info" class="formbox">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item>
              <span class="form_tit">{{ $t('lg.邮箱') }}</span>
              <el-input v-model="info.email" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span class="form_tit">{{ $t('lg.创建时间') }}</span>
              <el-input v-model="info.create_time" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span class="form_tit">{{ $t('lg.店铺名称') }}</span>
              <el-input v-model="info.shop_name" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span class="form_tit">{{ $t('lg.平台类型') }}</span>
              <el-input v-model="info.type_name" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span class="form_tit">{{ $t('lg.状态') }}</span>
              <el-input v-if="info.status == 0" :value="$t('lg.未授权')" readonly></el-input>
              <el-input v-if="info.status == 1" :value="$t('lg.已授权')" readonly></el-input>
              <el-input v-if="info.status == 2" :value="$t('lg.已解绑')" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span class="form_tit">{{ $t('lg.店铺授权到期日') }}</span>
              <el-input v-model="info.end_time" readonly></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item v-if="info.status!=1">
              <el-button @click="copydata(info.fuwu_url)">{{$t('lg.去订购')}}</el-button>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item v-if="info.status != 1">
              <el-row>
                <el-col :span="12" :offset="6">
                  <el-button @click=" copydata(info.auth_url)">{{ $t('lg.店铺授权') }}</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :title="$t('lg.提示')" :visible.sync="diansan_show" :close-on-click-modal=false
      :close-on-press-escape=false :show-close='false' width="30%">
      <span style="font-size:20px;">{{ $t('lg.确定要绑定吗') }}?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="diansan_show = false">{{ $t('lg.取消') }}</el-button>
        <el-button type="primary" :loading='btn_loadinga' @click="authNotify">{{ $t('lg.确定') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters(['api_id']),
    },
    data() {
      return {
        total: 0,
        page: 1,
        tableData: [],
        loading: false,
        // 添加
        typeList: [],
        show: false,
        btn_loading: false,
        form: {
          type_id: '',
          shop_name: '',
        },
        rules: {
          type_id: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          shop_name: [
            { required: true, trigger: "blur", message: this.$t('lg.请输入') }
          ],
          api_id: [
            { required: true, trigger: "blur", message: this.$t('lg.请输入') }
          ],
        },
        // 详情
        info_show: false,
        info: {},

        // 绑定
        diansan_show: false,
        diansan: {
          shop_id: '',
          id: '',
          msg: '',
          refUserId: '',
          expiresTime: '',
        },
        btn_loadinga: false,

        idsarr: [],
        btn_allunbind: false,
        btn_alldel: false,
      };
    },
    methods: {
      getlist() {
        this.loading = true
        this.$post({
          url: "/app/member_shop/shopList",
          data: {
            page: this.page,
            api_id: this.api_id
          },
          success: (res) => {
            this.tableData = res.data.data
            this.total = res.data.total
            this.page = res.data.current_page
            setTimeout(() => {
              this.loading = false
            }, 200);
          },
          tip: () => {
            this.loading = false
          },
        })
      },
      pagechage(page) {
        this.page = page
        this.tableData = []
        this.getlist()
      },
      gettypeList() {
        this.$post({
          url: "/app/shop_type/typeList",
          success: (res) => {
            this.typeList = res.data
          },
          tip: () => {
          },
        })
      },
      // 添加
      onSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.btn_loading = true
            this.$post({
              url: "/app/member_shop/add",
              data: { ...this.form, ...{ api_id: this.api_id } },
              success: (res) => {
                this.$message({
                  message: this.$t('lg.成功'),
                  type: 'success'
                });
                setTimeout(() => {
                  this.show = false
                  this.pagechage(this.page)
                  this.btn_loading = false
                }, 1500);
              },
              tip: () => {
                setTimeout(() => {
                  this.btn_loading = false
                }, 1500);
              },
            })
          }
        });
      },
      //授权绑定
      authNotify() {
        this.btn_loadinga = true
        this.$post({
          url: "/app/diansan/authNotify",
          data: this.diansan,
          success: (res) => {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.diansan_show = false
              this.pagechage(this.page)
              this.btn_loadinga = false
            }, 1500);
          },
          tip: () => {
            setTimeout(() => {
              this.btn_loadinga = false
            }, 1500);
          },
        })
      },
      SelectionChange(data) {
        this.idsarr = data
      },
      // 列拖拽
      columnDrop() {
        const wrapperTr = document.querySelector('.draggable .el-table__header-wrapper tr');
        this.sortable = Sortable.create(wrapperTr, {
          animation: 180,
          delay: 0,
          onEnd: evt => {
            const oldItem = this.newList[evt.oldIndex];
            this.newList.splice(evt.oldIndex, 1);
            this.newList.splice(evt.newIndex, 0, oldItem);
          }
        });
      },
      lookdata(data) {
        this.info = data
        this.info_show = true
      },
      copydata(data) {
        window.open(data)
      },
      // 单个解绑
      unbind(data) {
        this.$confirm(`${this.$t('lg.解绑店铺之后,将不能下载新的订单,是否继续')}?`, this.$t('lg.提示'), {
          confirmButtonText: this.$t('lg.确定'),
          cancelButtonText: this.$t('lg.取消'),
          type: 'warning'
        }).then(() => {
          this.$post({
            url: "/app/member_shop/unbind",
            data: {
              id: data.id
            },
            success: (res) => {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.pagechage(this.page)
            },
            tip: () => { },
          })
        }).catch(() => { });
      },
      // 多个解绑
      allunbind() {
        if (!this.idsarr.length) {
          this.$message({
            message: this.$t('lg.请选择解绑店铺'),
            type: 'warning'
          });
          return
        }
        let ids = []
        this.idsarr.map((item) => {
          ids.push(item.id)
        })
        this.btn_allunbind = true
        this.$post({
          url: "/app/member_shop/unbind",
          data: {
            id: ids.join()
          },
          success: (res) => {
            this.$message({
              type: 'success',
              message: res.msg
            });
            setTimeout(() => {
              this.btn_allunbind = false
              this.pagechage(this.page)
            }, 1300);
          },
          tip: () => { },
        })
      },
      deleteShop() {
        if (!this.idsarr.length) {
          this.$message({
            message: this.$t('lg.请选择删除店铺'),
            type: 'warning'
          });
          return
        }
        let ids = []
        this.idsarr.map((item) => {
          ids.push(item.id)
        })
        this.btn_allunbind = true
        this.$post({
          url: "/app/member_shop/deleteShop",
          data: {
            id: ids.join()
          },
          success: (res) => {
            this.$message({
              type: 'success',
              message: res.msg
            });
            setTimeout(() => {
              this.btn_allunbind = false
              this.pagechage(this.page)
            }, 1300);
          },
          tip: () => { },
        })
      }
    },
    created() {
      this.getlist()
      this.gettypeList()

      if (this.$route.query.id && this.$route.query.expiresTime && this.$route.query.refUserId) {
        this.diansan = {
          shop_id: this.$route.query.shop_id || '',
          id: this.$route.query.id || '',
          msg: this.$route.query.msg || '',
          refUserId: this.$route.query.refUserId || '',
          expiresTime: this.$route.query.expiresTime || '',
        }
        this.diansan_show = true
      }
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .searchbox {
      width: 100%;
      min-width: 500px;
      padding: 10px 20px;
      background: #fff;
      border-bottom: 1px solid #babdcd;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      /deep/.el-form {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .el-form-item {
          margin: 0 20px 0 0 !important;
        }
      }
      /deep/.el-button {
        background-color: #d6f3e3;
        border-radius: 10px;
        color: #3b3b3b;
        border-color: #d6f3e3;
        align-self: flex-end;
      }
    }
    .imgbox {
      width: 100%;
      padding: 10px 20px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      >div {
        width: 120px;
        height: 57px;
        padding: 4px;
        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
          border-radius: 4px;
          object-fit: contain;
          // filter: grayscale(1);
        }
        img:hover {
          // filter: grayscale(0);
          border: 2px solid $color;
        }
        .actiive {
          // filter: grayscale(0);
          border: 2px solid $color;
        }
      }
    }
    .tablebox {
      width: 100%;
      padding: 20px;
    }
    .formbox {
      /deep/.el-form-item {
        margin-bottom: 30px !important;
        .el-form-item__content {
          width: 100%;
          .el-button {
            width: 100%;
            height: 48px;
            background: $color;
            border-radius: 5px;
            border-color: $color;
          }
        }
        .el-button {
          height: 40px !important;
          color: #fff;
        }
      }
    }
  }
</style>